import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { AdTargetingPrefetch } from 'site-modules/shared/components/native-ad/inventory-ad-targeting/ad-targeting';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';

export const PersonalizeSearchAdTargetingPrefetch = connectToModel(AdTargetingPrefetch, {
  adTargeting: bindToPath(PersonalizedSearchPaths.getAdTargeting(), PersonalizedSearchModel),
});
PersonalizeSearchAdTargetingPrefetch.displayName = 'PersonalizeSearchAdTargetingPrefetch';
